<template>
    <div class="box" ref="myBox" >
        <h2
        @mousedown="handleDown"
        @mousemove="handleMove"
        @mouseup="handleUp"
        >
            <a href="javascript:;"
            @click="handleClick"
            @mousedown="handleAdown"
            >点击回放拖动轨迹</a>
        </h2>
        <p><strong>Drag:</strong><span>{{ bDrag }}</span></p>
        <p><strong>offsetTop:</strong><span>{{ span1  }}</span></p>
        <p><strong>offsetLeft:</strong><span>{{ span2 }}</span></p>
    </div>
</template>
<script>
import { setInterval, clearInterval } from 'timers';
export default {
    name:'Mavs',
    data(){
        return{
            bDrag:false,
            span1:'',
            span2:'',
            disX:0,
            disY:0,
            pos:[
                {x:'', y:''}
            ]
        }
    },    
    
    methods:{
        handleInitlalSpan(){
            var elem = this.$refs.myBox;
            this.span1=elem.offsetTop;
            this.span2=elem.offsetLeft;
        },
        handleDown(){
            var elem = this.$refs.myBox;
            this.bDrag=true;
            this.disX = event.clientX - elem.offsetLeft;;
            this.disY = event.clientY - elem.offsetTop;
            //console.log(this.disX);
            //console.log(this.disY);

            this.pos.push({x:elem.offsetLeft, y:elem.offsetTop});

            return false;
        },
        handleMove(){
            if(!this.bDrag) return;
            var elem = this.$refs.myBox;
            var iL = event.clientX - this.disX;
            var iT = event.clientY - this.disY;
            var maxL = document.documentElement.clientWidth - elem.offsetWidth;
            var maxT = document.documentElement.clientHeight - elem.offsetHeight;

            iL = iL < 0 ? 0 : iL;
            iL = iL > maxL ? maxL : iL;
            iT = iT < 0 ? 0 : iT;
            iT = iT > maxT ? maxT : iT;

            elem.style.marginTop = 0;
            elem.style.marginLeft = 0;
            elem.style.left = iL + 'px';
            elem.style.top = iT + 'px';

            this.pos.push({x:iL, y:iT});

            this.span1=elem.offsetTop;
            this.span2 = elem.offsetLeft;

        },
        handleUp(){
            var elem = this.$refs.myBox;
            this.bDrag=false;
            this.span1=elem.offsetTop;
            this.span2 = elem.offsetLeft;
            
        },
        handleClick(){
            var _this=this;
            var elem = this.$refs.myBox;
            if(this.pos.length == 1) return;
            var timer=setInterval(function(){
                var myPos=_this.pos.pop();
                myPos ? (elem.style.left = myPos.x + 'px', elem.style.top = myPos.y + 'px',_this.status()) : clearInterval(timer)
            },30);
        },
        handleAdown(){
            event.cancelBubble=true
        },
        status(){
            var elem=this.$refs.myBox;
            this.span1=elem.offsetTop;
            this.span2=elem.offsetLeft;
        }
    },
    mounted(){
        this.handleInitlalSpan()
        document.addEventListener('mousemove',this.handleMove)
    }
}
</script>
<style>
html, body{
    overflow: hidden;
}
body, div, h2, p{
    margin: 0;
    padding: 0;
}
body{
    color: #fff;
    background: #000;
    font: 12px/2 arial;
}
p{
    padding: 0 10px;
    margin-top: 10px;
}
span{
    color:#ff0;
    padding-left: 5px;
}
.box{
    position: absolute;
    width: 300px;
    height: 150px;
    background: #333;
    border: 2px solid #ccc;
    top:50%;
    left: 50%;
    margin: -75px 0 0 -150px;
}
.box h2{
    height: 25px;
    cursor: move;
    background: #222;
    border-bottom: 2px solid #ccc;
    text-align: right;
    padding: 0 10px;
}
.box h2 a{
    color: #fff;
    font: 12px/25px arial;
    text-decoration: none;
    outline: none;
    vertical-align: super;
}
</style>
